export const InvoiceGenerator = {



  companyData() {
    return {
      name: "Thurent",
      gstin: "22222222222222",
      sacCode: "00440035",
      logoPath: "/logo.png", // update if needed
      address:
        "THURENT TECH SERVICES PRIVATE LIMITED T-Hub Phase II Gachibowli",
      city: "Hyderabad",
      state: "Telangana",
      pincode: "500060",
      mobile: "+91 74167-34499",
      email: "nick@thurent.com",
      website: "https://thurent.in",
      accountName: "DEMO ACCOUNT - MANDAP",
      accountNumber: "12345678901",
      bankName: "STATE BANK OF INDIA",
      ifscCode: "SBIN0001234",
      bankBranch: "Main Branch",
    }
  },

  // ✅ Generate Invoice Number (same as Flutter)
  generateInvoiceNumber(eventId) {
    const now = new Date();

    const dateStr = now.toISOString().slice(0, 10).replace(/-/g, "");
    const timeStr = now.toTimeString().slice(0, 8).replace(/:/g, "");

    return `${dateStr}-${timeStr}-${eventId}`;
  },

  // ================= ESTIMATE =================
  generateEstimateInvoice(eventCart) {
    let items = [];
    let paymentSummarys = [];

    let subtotal = 0;
    let totalTax = 0;
    let paidAmount = 0;
    let pendingAmount = 0;

    console.log(eventCart.cateringProviders)
    console.log(eventCart.tentProviders)
    console.log(eventCart.priestProviders)

    // ================= CATERING =================
    eventCart.cateringProviders?.forEach((provider) => {
      if (provider.paymentSummary) {
        paymentSummarys.push({
          ...provider.paymentSummary,
          providerType: "Catering Services",
        });
      }

      paidAmount += provider.paid_amount || 0;
      pendingAmount += provider.balance_to_be_paid || 0;

      provider.services?.forEach((item) => {
        const itemTotal = item.total_amount || 0;
        const itemTax = item.gst_amount || 0;

        items.push({
          providerName: `${provider.providername}`,
          serviceType: "catering",
          description: `${item.meal?.name} • ${item.number_of_people} Guests`,
          amount: itemTotal - itemTax,
          tax: itemTax,
          total: itemTotal,
          details: {
            mealType: item.meal?.name,
            numberOfPeople: item.number_of_people,
            category: item.category?.name,
            gstPercentage: item.gst_percentage,
          },
        });

        subtotal += itemTotal - itemTax;
        totalTax += itemTax;
      });
    });

    // ================= TENT =================
    eventCart.tentProviders?.forEach((provider) => {
      if (provider.paymentSummary != null) {
        paymentSummarys.push({
          ...provider.paymentSummary,
          providerType: "Tent House Services",
        });
      }

      paidAmount += (provider.paidAmount ?? 0);
      pendingAmount += (provider.balanceToBePaid ?? 0);

      if (provider.isPackage == true) {
        const total = provider.pricing?.totalAmount ?? 0;
        const tax = provider.pricing?.gstAmount ?? 0;

        let description = "";
        for (var item of (provider.package?.packageItems ?? [])) {
          description = `${description} \n ${item.tentHouseService.serviceName}: (${item.itemQty ?? 1})`;
        }

        items.push({
          providerName: `${provider.providername}`,
          serviceType: "tent",
          description: `Package: ${provider.package?.packageName ?? 'Tent Package'}${description}`,
          amount: total - tax,
          tax: tax,
          total: total,
          details: {
            isPackage: true,
            packageName: provider.package?.packageName,
            gstPercentage: provider.pricing?.gstPercentage ?? 0,
          },
        });

        subtotal += (total - tax);
        totalTax += tax;

      } else {
        let total = 0;
        let tax = 0;
        let description = "";

        for (var item of (provider.items ?? [])) {
          total = provider.pricing?.totalAmount ?? 0;
          tax = provider.pricing?.gstAmount ?? 0;
          description = `${description} \n ${item.serviceName}: (${item.quantity ?? 1}),`;
        }

        items.push({
          providerName: `${provider.providername}`,
          serviceType: "tent",
          description: description,
          amount: total - tax,
          tax: tax,
          total: total,
          details: {
            isPackage: false,
            description: description,
            gstPercentage: provider.pricing?.gstPercentage ?? 0,
          },
        });

        subtotal += (total - tax);
        totalTax += tax;
      }
    });

    // ================= PRIEST =================
    eventCart.priestProviders?.forEach((item) => {
      if (item.paymentSummary) {
        paymentSummarys.push({
          ...item.paymentSummary,
          providerType: "Priest Services",
        });
      }

      paidAmount += item.paid_amount || 0;
      pendingAmount += item.balance_to_be_paid || 0;

      const total = item.pricing?.totalAmount || 0;
      const tax = item.pricing?.gstAmount || 0;

      items.push({
        providerName: item.providername || "",
        serviceType: "priest",
        description: item.isPackage
          ? `Package: ${item.packageDetails?.packageName || "Priest Package"}`
          : "Priest Service",
        amount: total - tax,
        tax: tax,
        total: total,
        details: {
          isPackage: item.isPackage,
          packageName: item.packageDetails?.packageName,
          gstPercentage: item.pricing?.gstPercentage || 0,
        },
      });

      subtotal += total - tax;
      totalTax += tax;
    });

    // ================= FINAL =================
    return {
      type: "estimate",
      invoiceNumber: this.generateInvoiceNumber(eventCart.event?.id),
      generatedDate: new Date(),

      eventId: eventCart.event?.id,
      eventTitle:eventCart.event?.eventTitle || eventCart.event?.eventType,
      eventType: eventCart.event?.eventType,
      eventDate: eventCart.event?.startDate,
      venue: eventCart.event?.venue,

      items,
      paymentSummarys,

      subtotal,
      totalTax,
      grandTotal: subtotal + totalTax,

      paidAmount,
      pendingAmount,

      paymentStatus: "pending",
    };
  },

  // ================= PAYMENT INVOICE =================
  generatePaymentInvoice(eventCart) {
    const estimate = this.generateEstimateInvoice(eventCart);

    return {
      ...estimate,
      type: "invoice",
      invoiceNumber: this.generateInvoiceNumber(eventCart.event?.id),
      pendingAmount: estimate.grandTotal - (estimate.paidAmount || 0),
      paymentStatus:
        (estimate.paidAmount || 0) >= estimate.grandTotal
          ? "paid"
          : "partiallyPaid",
      paymentDate: new Date(),
      paymentSummarys: [],
    };
  },

  // ================= RECEIPT =================
  generateReceiptInvoice(eventCart) {
    const estimate = this.generateEstimateInvoice(eventCart);

    return {
      ...estimate,
      type: "receipt",
      invoiceNumber: this.generateInvoiceNumber(eventCart.event?.id),
    };
  },
};